import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminApi } from '../../services/adminApi';
import { AdminLoading, AdminPageHeader, formatDate } from './adminShared';
import './AdminLayout.css';

const AdminDashboard: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [stats, setStats] = useState({
    totalStores: 0,
    activeStores: 0,
    totalUsers: 0,
    activeUsers: 0,
  });
  const [recentStores, setRecentStores] = useState<
    { store_id: string; store_name: string; created_at: string | null }[]
  >([]);

  useEffect(() => {
    const load = async () => {
      try {
        const [stores, users] = await Promise.all([
          adminApi.listStores(),
          adminApi.listUsers(),
        ]);

        setStats({
          totalStores: stores.total,
          activeStores: stores.items.filter((s) => s.active).length,
          totalUsers: users.total,
          activeUsers: users.items.filter((u) => u.active).length,
        });

        const sorted = [...stores.items].sort((a, b) => {
          const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
          const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
          return tb - ta;
        });
        setRecentStores(sorted.slice(0, 5));
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error cargando dashboard');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  if (loading) return <AdminLoading />;

  return (
    <>
      <AdminPageHeader title="Dashboard admin" />

      {error && <div className="admin-alert admin-alert-error">{error}</div>}

      <div className="admin-stats">
        <div className="admin-stat-card">
          <div className="admin-stat-label">Tiendas activas</div>
          <div className="admin-stat-value">
            {stats.activeStores}
            <span style={{ fontSize: 14, fontWeight: 400, color: 'var(--color-text-secondary)' }}>
              {' '}
              / {stats.totalStores}
            </span>
          </div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-label">Usuarios activos</div>
          <div className="admin-stat-value">
            {stats.activeUsers}
            <span style={{ fontSize: 14, fontWeight: 400, color: 'var(--color-text-secondary)' }}>
              {' '}
              / {stats.totalUsers}
            </span>
          </div>
        </div>
      </div>

      <div className="admin-card">
        <h2 style={{ margin: '0 0 16px', fontSize: 16 }}>Últimas tiendas</h2>
        {recentStores.length === 0 ? (
          <p style={{ color: 'var(--color-text-secondary)' }}>No hay tiendas registradas.</p>
        ) : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Tienda</th>
                  <th>Store ID</th>
                  <th>Creada</th>
                </tr>
              </thead>
              <tbody>
                {recentStores.map((store) => (
                  <tr key={store.store_id}>
                    <td>
                      <Link to={`/admin/stores/${store.store_id}`}>{store.store_name}</Link>
                    </td>
                    <td>{store.store_id}</td>
                    <td>{formatDate(store.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default AdminDashboard;
